var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-contents"
  }, [!_vm.isNewApp ? _c('div', {
    staticClass: "tag-text",
    class: _vm.$style.appTag,
    style: {
      'background-color': _vm.appBackgroundColor
    }
  }, [_vm._v(" " + _vm._s(_vm.category) + " ")]) : _c('div', {
    staticClass: "tag-text",
    class: _vm.$style.appNewTag,
    style: {
      'background-color': _vm.appBackgroundColor
    }
  }, [_vm._v("NEW ACCESS! ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }